import { makeProfileInjector } from '@profile/src/utils/makeInjector';
import { makeVestingSafeInjector } from '@vestingSafe/src/utils/makeInjector';
import { makeConversionProgramInjector } from '@conversionProgram/src/utils/makeInjector';
import { makeCreatorCornerInjector } from '@creatorCorner/src/utils/makeInjector';
export const loadInjectors = ({
  history,
  store
}) => {
  const injectors = [makeProfileInjector, makeVestingSafeInjector, makeConversionProgramInjector, makeCreatorCornerInjector];

  for (const injector of injectors) {
    injector({
      history: history,
      store: store
    });
  }
};